module.exports = __webpack_public_path__ + "static/media/pen-alt_active_red.80e3806b.svg";